import { theme } from '@qr-front/ui'
import { getVersionForClone } from '@qr-front/ui/utils'
import { isDemoModeAtom } from 'features/generator/generatorState'
import { atom } from 'jotai'

import { primaryColorAtom } from '@/content-from-sections/client'

export const SOCIAL_MEDIA_DEMO_PRIMARY_COLOR = getVersionForClone({
	base: theme.colors['light-purple'],
	clone1: '#FF93CD',
})

export const socialMediaPrimaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? SOCIAL_MEDIA_DEMO_PRIMARY_COLOR : get(primaryColorAtom),
)
